module.exports = __webpack_public_path__ + "static/img/253_TO8_2247.dbb638f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/253_TO8_2247.jpg
// module id = LZE6
// module chunks = 0